<template>
  <component class="text-cut" :is="name" :title="value">{{ value }}</component>
</template>
<script>
export default {
  name: 'TypoGraphy',
  props: {
    name: String,
    value: String
  }
};
</script>
<style>
.text-cut {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
